import React, { useEffect, useState } from "react";
import { FaComment, FaSpinner, FaUserCircle } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import Input from "../../components/input";
import useAxiosInstance from "../../hooks/useAxios";
// import Preview from "./components/preview";
import {
  MdArrowBack,
  MdCheckCircle,
  MdDateRange,
  MdHourglassEmpty,
  MdHourglassFull,
  MdTypeSpecimen,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { GoOrganization } from "react-icons/go";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Select from "react-select";
import { Spinner } from "flowbite-react";
import { useDebounce } from "use-debounce";
import { parseAbsoluteToLocal } from "@internationalized/date";
import { DatePicker } from "@adobe/react-spectrum";
// import DatePicker from "react-datepicker"
import { Button, defaultTheme, Provider } from "@adobe/react-spectrum";

const EditOrganisation = () => {
  const [formData, setFormData] = useState({
    id: 29,
    name: "frontend_testing_1",
    label: "",
    comment: "",
    enabled_google: false,
    enabled_onedrive: false,
    enabled_dropbox: false,
    enabled_box: false,
    expiry_date: "2099-12-31T00:00:00Z",
    account_type: 3,
    save_upload: true,
    template: 7,
    meta: {
      report_limits: {
        daily: 50,
        monthly: 500,
        running: 20,
        yearly: 0,
      },
      trial_to_paid_date: null,
      next_renewal_date: null,
    },
    layouts: [1],
    locked_layouts: [],
    workflow: [1, 2],
    locked_workflow: [3, 4, 5, 6, 8],
  });
  const [OrginalCompanyName, setOrginalCompnayName] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const org_id = searchParams.get("org_id");
  //   console.log(data)
  const [steps, setSteps] = useState(0);
  const { organisation } = useSelector((s) => s.globalAuth);
  const [errorInName, setErrorInName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formInfoLoading, setFormInfoLoading] = useState(false);
  const [seachWorkFlow, setSearchWorkFlow] = useState("");
  const [workflowTypesList, setWorkflowTypesList] = useState([
    {
      id: 8,
      name: "Private company materials",
    },
    {
      id: 1,
      name: "Industry reports",
    },
    {
      id: 2,
      name: "Call transcripts",
    },
    {
      id: 3,
      name: "Internal knowledge repo",
    },
    {
      id: 5,
      name: "Public company fillings",
    },
    {
      id: 6,
      name: "Company financials",
    },
    {
      id: 4,
      name: "Pitch decks",
    },
  ]);
  const [templatesList, setTemplatesList] = useState([
    {
      id: 6,
      name: "Sage Collective",
    },
    {
      id: 3,
      name: "Guggenheim Partners",
    },
    {
      id: 8,
      name: "Storyhouse",
    },
    {
      id: 4,
      name: "Pale Blue Dot",
    },
    {
      id: 7,
      name: "wokelo",
    },
    {
      id: 2,
      name: "Bison Ventures",
    },
    {
      id: 12,
      name: "Anthos",
    },
    {
      id: 11,
      name: "Premji",
    },
    {
      id: 10,
      name: "Berkshire Partners",
    },
    {
      id: 9,
      name: "Sevensevensix",
    },
    {
      id: 5,
      name: "TSMG",
    },
  ]);
  const [accountTypeList, setAccountTypeList] = useState([
    {
      id: 1,
      name: "Trial",
    },
    {
      id: 2,
      name: "Paid",
    },
    {
      id: 3,
      name: "sandbox",
    },
    {
      id: 4,
      name: "internal",
    },
  ]);
  const [LayoutList, setLayoutList] = useState([
    {
      id: 1,
      name: "Default",
    },
  ]);
  const [
    accountType_id_to_accountType_name,
    setAccountType_id_to_accountType_name,
  ] = useState({});
  const [searchLayout, setSearchLayout] = useState("");
  const [enabledMetaKeys, setEnabledMetaKeys] = useState(
    Object.keys(formData.meta)
  );
  const [isLogoUploading, setIsLogoUploading] = useState(false);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");
  const [metaCompanySearchForPermalink, setMetaCompanySearchForPermalink] =
    useState("");
  const [metaCompanySearchResults, setMetaCompanySearchResults] = useState([]);
  const [metaPermalinkQuery] = useDebounce(metaCompanySearchForPermalink, 1000);
  const [metaPeramlinkResultsLoading, setMetaPermalinkResultsLoading] =
    useState(false);
  const [isMetaPermalinkShowMoreOn, setIsMetaPermalinkShowMoreButtonOn] =
    useState(false);

  const [orgsProducts, setOrgsProducts] = useState([]);

  useEffect(() => {
    if (metaPermalinkQuery !== "") {
      setMetaPermalinkResultsLoading(true);
      axiosInstance
        .post("/assets/get_company_list/", {
          company_type: "all",
          name: metaPermalinkQuery,
          search_by: "company name",
        })
        .then((res) => {
          setIsMetaPermalinkShowMoreButtonOn(true);
          setMetaCompanySearchResults(res.data.data);
          setMetaPermalinkResultsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setMetaPermalinkResultsLoading(false);
        });
    }
  }, [metaPermalinkQuery]);

  const [metaData, setMetaData] = useState({
    logo: "",
    webhook: "",
    permalink: "",
    sso_enabled: [],
    enable_uploaded_file_page: false,
    disabled_file_upload_ppt_generator: false,
    report_limits: {
      daily: 0,
      monthly: 0,
      running: 0,
      yearly: 0,
    },
    trial_to_paid_date: null,
    next_renewal_date: null,
    zapier_webhook: "",
    disabled_export: 0,
    external_access: {
      enabled: false,
      sasToken: "",
    },
    msal_config: {
      clientId: "",
      authority: "",
      tenant_id: "",
    },
    enabled_connectors: {
        google_drive: false,
        dropbox: false,
     },
    pitchbook_proxy: "",
    pitchbook_api_key: "",
    total_seats: 0,
    allowded_domains: [],
    validate_token: true,
    disabled_share: false,
    cache_time_period: 0,
    ppt_generator_file_attachment_limit: 0,
    ppt_generator_max_number_of_slides: 0,
    ppt_generator_file_attachment_limit_single_slide: 0,
    ppt_generator_file_attachment_limit_multi_slide: 0,
    ppt_generator_types_of_file_upload_single_slide: [],
    ppt_generator_types_of_file_upload_multi_slide: [],
    ppt_generator_approch_single_slide: [],
    ppt_generator_approch_multi_slide: [],
    enable_newsletter_export: false,
    enable_file_connectors: false,
    email_workflow_authentication_key: "",
    is_email_research_allowed: false,
    custom_workflow_enable: false,
    custom_agents_enable: false,
    newsletter_custom_analysis: false,
  });
  const axiosInstance = useAxiosInstance();
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (formData.expiry_date == "") {
      delete formData.expiry_date;
    }
    if (!formData.meta.trial_to_paid_date) {
      delete formData.meta.trial_to_paid_date;
    }
    if (!formData.meta.next_renewal_date) {
      delete formData.meta.next_renewal_date;
    }
    formData["account_type"] = Number(formData.account_type);
    setIsLoading(true);
    axiosInstance
      .post("/accounts/edit_a_org/", { ...formData, org_id: Number(org_id) })
      .then((res) => {
        if (res.data.status === "success") {
          toast.success(`Org is successfully edited.`);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.error("something went wrong!");
      });
  };

  useEffect(() => {
    if (Object.keys(organisation).includes(formData?.name)) {
      setErrorInName("A Org with Name already exists!");
    } else {
      setErrorInName("");
    }
    if (formData?.name == OrginalCompanyName) {
      setErrorInName("");
    }
  }, [formData?.name]);

  useEffect(() => {
    setFormInfoLoading(true);
    axiosInstance
      .get("/accounts/get_org_management_mappings/")
      .then((res) => {
        setAccountTypeList(res.data?.mappings?.account_types);
        setTemplatesList(res.data?.mappings?.templates);
        let mapping = {};
        res.data?.mappings?.account_types?.forEach((type) => {
          mapping[type.id] = type.name;
        });
        setAccountType_id_to_accountType_name(mapping);
        setWorkflowTypesList(res.data?.mappings?.workflow_types);

        setLayoutList(res?.data?.mappings?.layouts);
        axiosInstance
          .get(`/accounts/get_a_org_details/?org_id=${org_id}`)
          .then((org_details_response) => {
            const orgData = org_details_response.data.org_data;
            if (!orgData.meta) {
              orgData.meta = {};
            }
            setFormData(orgData);
            setOrginalCompnayName(orgData.name);
            // let expiry_date = org_details_response.data.org_data.expiry_date
            // let new_expiry_date = new Date(expiry_date)
            // new_expiry_date = (`${new_expiry_date.getFullYear()}-${new_expiry_date.getMonth()}-${new_expiry_date.getDate()}T${new_expiry_date.getHours()}:${new_expiry_date.getMinutes()}`)
            // setFormData((prev)=>({...prev,expiry_date:new_expiry_date}))
            // axiosInstance
            //   .get(
            //     `/accounts/sandbox-dashboard/?org=${org_details_response?.data?.org_data?.name}`
            //   )
            //   .then((res) => {
            //     let datata = res.data.user_org_products;
            //     // setOrgsProducts([
            //     //   ...datata.data,
            //     //   datata.features["newsletter"],
            //     // ]);

            setFormInfoLoading(false);
            //   });
            const apiMetaKeys = Object.keys(
              org_details_response.data.org_data.meta
            );
            setEnabledMetaKeys(apiMetaKeys);
            //upadting metaData form data based on response from backend
            let newMetaData = JSON.parse(JSON.stringify(metaData));
            Object.keys(org_details_response.data.org_data.meta).forEach(
              (metakey) => {
                newMetaData[metakey] =
                  org_details_response.data.org_data.meta[metakey];
              }
            );
            console.log(newMetaData);
            setMetaData(newMetaData);
          });
      })
      .catch((err) => {
        setFormInfoLoading(false);
        console.log(err);
      });
  }, [org_id]);

  const get_workflow_search_results = (allWorkflows, search) => {
    console.log(allWorkflows);
    if (search === "") {
      return allWorkflows;
    } else
      return allWorkflows?.filter(
        (item) =>
          item?.name?.toLowerCase()?.includes(search?.toLowerCase()) ||
          String(item?.id)?.includes(String(search))
      );
  };

  const initate_file_upload = (file, fileName) => {
    setIsLogoUploading(true);
    const formData_ = new FormData();
    formData_.append("files", file);
    formData_.append("permalink", fileName);
    formData_.append("is_template_logos", true);
    axiosInstance
      .post("/assets/upload_logo_image/", formData_)
      .then((res) => {
        console.log(res.data);
        setIsLogoUploading(false);
      })
      .catch((err) => {
        setIsLogoUploading(false);
      });
  };

  useEffect(() => {
    console.log("meta_data", metaData);
    console.log("formData", formData);
    console.log("enabledMetaKeys", enabledMetaKeys);
  }, [metaData, formData, enabledMetaKeys]);

  return (
    <div className="">
      <div className="flex justify-center">
        <div className="w-[680px] flex items-center mt-10">
          <div className="flex flex-col items-center justify-center w-18">
            {steps <= 0 ? <MdHourglassEmpty /> : <MdCheckCircle />}
            <div className="px-2 text-xs text-center">Step 1</div>
          </div>
          <div
            className={`w-full h-1 ${steps <= 0 ? "bg-slate-300" : "bg-black"}`}
          ></div>
          <div className="flex flex-col items-center justify-center w-18">
            {steps <= 1 ? <MdHourglassEmpty /> : <MdHourglassFull />}
            <div className="px-2 text-xs text-center">Meta 1</div>
          </div>

          <div
            className={`w-full h-1 ${steps <= 1 ? "bg-slate-300" : "bg-black"}`}
          ></div>

          <div className="flex flex-col items-center justify-center w-18">
            {steps <= 2 ? <MdHourglassEmpty /> : <MdHourglassFull />}
            <div className="px-2 text-xs text-center">Meta 2</div>
          </div>

          <div
            className={`w-full h-1 ${steps <= 2 ? "bg-slate-300" : "bg-black"}`}
          ></div>

          <div className="flex flex-col items-center justify-center w-18">
            {steps <= 3 ? <MdHourglassEmpty /> : <MdHourglassFull />}
            <div className="px-2 text-xs text-center">Meta 3</div>
          </div>

          <div
            className={`w-full h-1 ${steps <= 3 ? "bg-slate-300" : "bg-black"}`}
          ></div>

          <div className="flex flex-col items-center justify-center w-18">
            {steps <= 4 ? <MdHourglassEmpty /> : <MdHourglassFull />}
            <div className="px-2 text-xs text-center">Meta 4</div>
          </div>

          <div
            className={`w-full h-1 ${steps <= 4 ? "bg-slate-300" : "bg-black"}`}
          ></div>

          <div className="flex flex-col items-center justify-center w-18">
            {steps <= 5 ? <MdHourglassEmpty /> : <MdHourglassFull />}
            <div className="px-2 text-xs text-center">Preview</div>
          </div>
        </div>
      </div>
      <div className={` w-full justify-center p-5 ${"items-start "} flex`}>
        {steps === 0 && (
          <>
            {formInfoLoading ? (
              <p className="p-3 mt-5">Loading...</p>
            ) : (
              <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
                <p className="mb-4 text-2xl font-semibold">Edit Organisation</p>
                <div className="mb-2 text-sm font-semibold">Name*</div>
                {errorInName && (
                  <p className="text-sm text-red-300">{errorInName}</p>
                )}
                <Input
                  value={formData.name}
                  onChange={(e) => {
                    setFormData({ ...formData, name: e.target.value });
                  }}
                  placeholder="Enter the name"
                />

                <div className="mt-4 mb-2 text-sm font-semibold">Label</div>
                <Input
                  value={formData.label}
                  onChange={(e) => {
                    setFormData({ ...formData, label: e.target.value });
                  }}
                  placeholder="Enter the label"
                />

                <div className="mt-4 mb-2 text-sm font-semibold">Comment</div>
                <Input
                  value={formData.comment}
                  onChange={(e) => {
                    setFormData({ ...formData, comment: e.target.value });
                  }}
                  placeholder="Enter the comment"
                />

                <div className="mt-4 mb-2 text-sm font-semibold">
                  Expiry date
                </div>
                {/* <Input
                  type={'datetime-local'}
                  value={formData.expiry_date}
                  onChange={(e) => {
                    setFormData({ ...formData, expiry_date: e.target.value });
                  }}
                  placeholder="Enter the Expiry date"
                /> */}
                <Provider theme={defaultTheme} colorScheme="light">
                  <DatePicker
                    onChange={(value) => {
                      const next =
                        value && typeof value.toAbsoluteString === "function"
                          ? value.toAbsoluteString()
                          : value
                          ? `${String(value)}T00:00:00Z`
                          : null;
                      setFormData({
                        ...formData,
                        expiry_date: next,
                      });
                    }}
                    defaultValue={parseAbsoluteToLocal(
                      (formData.expiry_date || "").includes("T")
                        ? formData.expiry_date
                        : `${formData.expiry_date}T00:00:00Z`
                    )}
                  />
                </Provider>

                <div className="mt-4 mb-2 text-sm font-semibold">
                  Next Renewal Date
                </div>
                <Provider theme={defaultTheme} colorScheme="light">
                  <DatePicker
                    onChange={(value) => {
                      const next =
                        value && typeof value.toAbsoluteString === "function"
                          ? value.toAbsoluteString()
                          : value
                          ? `${String(value)}T00:00:00Z`
                          : null;
                      setFormData({
                        ...formData,
                        meta: {
                          ...formData.meta,
                          next_renewal_date: next,
                        },
                      });
                    }}
                    value={
                      formData.meta.next_renewal_date
                        ? parseAbsoluteToLocal(
                            formData.meta.next_renewal_date.includes("T")
                              ? formData.meta.next_renewal_date
                              : `${formData.meta.next_renewal_date}T00:00:00Z`
                          )
                        : undefined
                    }
                  />
                </Provider>

                <div className="mt-4 mb-2 text-sm font-semibold">
                  Trial to Paid date
                </div>
                <Provider theme={defaultTheme} colorScheme="light">
                  <DatePicker
                    onChange={(value) => {
                      const next =
                        value && typeof value.toAbsoluteString === "function"
                          ? value.toAbsoluteString()
                          : value
                          ? `${String(value)}T00:00:00Z`
                          : null;
                      setFormData({
                        ...formData,
                        meta: {
                          ...formData.meta,
                          trial_to_paid_date: next,
                        },
                      });
                    }}
                    value={
                      formData.meta.trial_to_paid_date
                        ? parseAbsoluteToLocal(
                            formData.meta.trial_to_paid_date.includes("T")
                              ? formData.meta.trial_to_paid_date
                              : `${formData.meta.trial_to_paid_date}T00:00:00Z`
                          )
                        : undefined
                    }
                  />
                </Provider>

                <div className="mt-4 mb-2 text-sm font-semibold">
                  Account Type*
                </div>
                <select
                  value={formData.account_type}
                  onChange={(e) => {
                    setFormData({ ...formData, account_type: e.target.value });
                  }}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-0 focus:outline-gray-400 "
                  placeholder="Enter your password"
                >
                  {[{ id: "", name: "choose" }, ...accountTypeList]?.map(
                    (account_type) => (
                      <option value={account_type.id}>
                        {account_type.name}
                      </option>
                    )
                  )}
                </select>

                <div className="mt-4 mb-2 text-sm font-semibold">
                  Data Upload
                </div>
                <div className="grid grid-cols-4 ml-2">
                  <div className="flex items-center gap-1">
                    Google{" "}
                    <input
                      checked={formData.enabled_google}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          enabled_google: e.target.checked,
                        });
                      }}
                      type="checkbox"
                    />
                  </div>
                  <div className="flex items-center gap-1">
                    Onedrive{" "}
                    <input
                      // disabled
                      checked={formData.enabled_onedrive}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          enabled_onedrive: e.target.checked,
                        });
                      }}
                      type="checkbox"
                    />
                  </div>

                  <div className="flex items-center gap-1">
                    Dropbox{" "}
                    <input
                      checked={formData.enabled_dropbox}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          enabled_dropbox: e.target.checked,
                        });
                      }}
                      type="checkbox"
                    />
                  </div>

                  <div className="flex items-center gap-1">
                    Box{" "}
                    <input
                      checked={formData.enabled_box}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          enabled_box: e.target.checked,
                        });
                      }}
                      type="checkbox"
                    />
                  </div>
                </div>

                <div className="mt-4 mb-2 text-sm font-semibold">Templates</div>
                <Select
                  value={formData.template}
                  onChange={(e) => {
                    setFormData({ ...formData, template: e.value });
                  }}
                  options={[{ id: "", name: "choose" }, ...templatesList].map(
                    (option) => ({ value: option.id, label: option.name })
                  )}
                  className="w-full"
                  placeholder={
                    templatesList.find(
                      (template) => template.id === formData.template
                    ).name
                  }
                />

                <div className="mt-4 mb-2 text-sm font-semibold">
                  Save Uploaded files :{" "}
                  <input
                    checked={formData.save_upload}
                    type="checkbox"
                    onClick={() => {
                      setFormData({
                        ...formData,
                        save_upload: !formData.save_upload,
                      });
                    }}
                  />
                </div>

                {/* <div className="mt-4 mb-2 text-xl font-semibold">Access</div> */}

                {/* <div className="mt-2 mb-2 text-sm font-semibold">
                  Multifile Qna
                </div>
                <div className="mt-2 mb-2 ml-5 text-sm font-semibold">
                  Workflows
                </div>
                <div>
                  <div className="mx-5">
                    <Input
                      placeholder={"Search workflow"}
                      value={seachWorkFlow}
                      onChange={(e) => {
                        setSearchWorkFlow(e.target.value);
                      }}
                    />
                    <div className="h-64 overflow-y-auto">
                      <table className="w-full mt-3">
                        <thead className="text-left border-b">
                          <th className="px-2 py-1 text-sm text-gray-700">
                            Name
                          </th>
                          <th className="px-2 py-1 text-sm text-gray-700">
                            isLocked
                          </th>
                          <th className="px-2 py-1 text-sm text-gray-700">
                            isUnlocked
                          </th>
                        </thead>
                        <tbody className="divide-y">
                          {get_workflow_search_results(
                            workflowTypesList,
                            seachWorkFlow
                          )?.map((workflow_type) => {
                            return (
                              <tr>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {workflow_type.name}
                                </td>

                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  <input
                                    checked={formData?.locked_workflow?.includes(
                                      workflow_type.id
                                    )}
                                    onClick={() => {
                                      let locked_workflow = [];
                                      if (
                                        formData?.locked_workflow?.includes(
                                          workflow_type.id
                                        )
                                      ) {
                                        locked_workflow =
                                          formData?.locked_workflow?.filter(
                                            (id) => id != workflow_type.id
                                          );
                                      } else {
                                        locked_workflow = [
                                          ...formData?.locked_workflow,
                                          workflow_type.id,
                                        ];
                                      }
                                      setFormData({
                                        ...formData,
                                        locked_workflow: locked_workflow,
                                      });
                                    }}
                                    type="checkbox"
                                  />
                                </td>

                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  <input
                                    checked={formData?.workflow?.includes(
                                      workflow_type.id
                                    )}
                                    onClick={() => {
                                      let workflow = [];
                                      if (
                                        formData?.workflow?.includes(
                                          workflow_type.id
                                        )
                                      ) {
                                        workflow = formData?.workflow?.filter(
                                          (id) => id != workflow_type.id
                                        );
                                      } else {
                                        workflow = [
                                          ...formData?.workflow,
                                          workflow_type.id,
                                        ];
                                      }
                                      setFormData({
                                        ...formData,
                                        workflow: workflow,
                                      });
                                    }}
                                    type="checkbox"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="mt-2 mb-2 text-sm font-semibold">DRS</div>
                <div className="mt-2 mb-2 ml-5 text-sm font-semibold">
                  Layouts
                </div>
                <div>
                  <div className="mx-5">
                    <Input
                      placeholder={"Search Layout"}
                      value={searchLayout}
                      onChange={(e) => {
                        setSearchLayout(e.target.value);
                      }}
                    />
                    <div className="h-64 overflow-y-auto">
                      <table className="w-full mt-3">
                        <thead className="text-left border-b">
                          <th className="px-2 py-1 text-sm text-gray-700">
                            Name
                          </th>
                          <th className="px-2 py-1 text-sm text-gray-700">
                            isLocked
                          </th>
                          <th className="px-2 py-1 text-sm text-gray-700">
                            isUnlocked
                          </th>
                        </thead>
                        <tbody className="divide-y">
                          {get_workflow_search_results(
                            LayoutList,
                            searchLayout
                          )?.map((layout_obj) => {
                            return (
                              <tr>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {layout_obj.name}
                                </td>

                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  <input
                                    checked={formData?.locked_layouts?.includes(
                                      layout_obj.id
                                    )}
                                    onClick={() => {
                                      let locked_layouts = [];
                                      if (
                                        formData?.locked_layouts?.includes(
                                          layout_obj.id
                                        )
                                      ) {
                                        locked_layouts =
                                          formData?.locked_layouts?.filter(
                                            (id) => id != layout_obj.id
                                          );
                                      } else {
                                        locked_layouts = [
                                          ...formData?.locked_layouts,
                                          layout_obj.id,
                                        ];
                                      }
                                      setFormData({
                                        ...formData,
                                        locked_layouts: locked_layouts,
                                      });
                                    }}
                                    type="checkbox"
                                  />
                                </td>

                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  <input
                                    checked={formData?.layouts?.includes(
                                      layout_obj.id
                                    )}
                                    onClick={() => {
                                      let layouts = [];
                                      if (
                                        formData?.layouts?.includes(
                                          layout_obj.id
                                        )
                                      ) {
                                        layouts = formData?.layouts?.filter(
                                          (id) => id != layout_obj.id
                                        );
                                      } else {
                                        layouts = [
                                          ...formData?.layouts,
                                          layout_obj.id,
                                        ];
                                      }
                                      setFormData({
                                        ...formData,
                                        layouts: layouts,
                                      });
                                    }}
                                    type="checkbox"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> */}
                {/* Orgs Products */}
                <div>
                  <div className="flex justify-between w-full mt-4 mb-2 text-xl font-semibold">
                    <p>Orgs Products</p>

                    <div>
                      <Link to={`/dashboardTiles/?org_name=${formData.name}`}>
                        <button className="mr-2 text-sm underline">View</button>
                      </Link>
                      <Link to={`/subscriptions/?org_name=${formData.name}`}>
                        <button className="text-sm underline">Edit</button>
                      </Link>
                    </div>
                  </div>

                  {/* <div className="overflow-x-auto h-[180px]  overflow-y-auto mt-4 border rounded-lg">
                    <table className="w-full">
                      <thead className="text-left border-b">
                        <th className="px-2 py-1 text-sm text-gray-700">
                          code
                        </th>
                        <th className="px-2 py-1 text-sm text-gray-700">
                          workflow_type
                        </th>
                        <th className="px-2 py-1 text-sm text-gray-700">
                          name
                        </th>
                        <th className="px-2 py-1 text-sm text-gray-700">
                          order_preference
                        </th>
                        <th className="px-2 py-1 text-sm text-gray-700">
                          description
                        </th>
                        <th className="px-2 py-1 text-sm text-gray-700">
                          subscription
                        </th>
                        <th className="px-2 py-1 text-sm text-gray-700">
                          resultPageType
                        </th>
                      </thead>
                      <tbody className="divide-y">
                        {orgsProducts?.filter((e) => !e.subscription.includes("Hidden"))?.map((product, index) => {
                            return (
                              <tr
                                key={index}
                                className="bg-white odd:bg-gray-50"
                              >
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {product?.code}
                                </td>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {product?.workflow_type}
                                </td>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {product?.name}
                                </td>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {product?.order_preference}
                                </td>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {product?.description}
                                </td>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {product?.subscription}
                                </td>
                                <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                  {product?.resultPageType}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div> */}
                </div>
                <button
                  disabled={isLoading}
                  className="flex gap-1 items-center px-2 py-1 mt-2 border border-black bg-black disabled:bg-[#b6b6b6] disabled:text-white text-white rounded-lg"
                  onClick={() => {
                    setSteps((prev) => prev + 1);
                  }}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
        {steps == 1 && (
          <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
            <p className="mb-4 text-2xl font-semibold">Meta</p>

            {/* Logo          */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Logo</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("logo")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("logo")
                        ? prev.filter((item) => item !== "logo")
                        : [...prev, "logo"]
                    );
                  }}
                />
              </div>

              <div className="mt-4 mb-2 text-sm font-semibold">Logo Value</div>
              <Input
                type={"text"}
                value={metaData.logo}
                onChange={(e) => {
                  setFileName(`${e.target.value}-light.png`);
                  setMetaData({ ...metaData, logo: e.target.value });
                }}
              />
              <div className="mt-4 mb-2 text-sm font-semibold">File Name</div>
              <Input
                type={"text"}
                value={fileName}
                onChange={(e) => {
                  setFileName(e.target.value);
                }}
              />
              <p className="mt-4 mb-2 text-sm font-semibold">Logo file</p>
              <Input
                type={"file"}
                // value={formData.logo}
                onChange={(e) => {
                  setFile(e.target.files[0]);
                }}
                placeholder="Enter the Logo"
              />
              {file && (
                <>
                  <p className="mt-2">Preview</p>
                  <img className="h-14" src={URL.createObjectURL(file)} />
                </>
              )}
              <button
                onClick={() => initate_file_upload(file, fileName)}
                className="px-2 py-1 text-sm text-white bg-black rounded-lg"
              >
                {!isLogoUploading ? "upload" : "Loading..."}
              </button>
              {isLogoUploading && <Spinner />}
            </div>
            {/* Reports_limit */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Report limits</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("report_limits")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("report_limits")
                        ? prev.filter((item) => item !== "report_limits")
                        : [...prev, "report_limits"]
                    );
                  }}
                />
              </div>

              <div className="mt-4 mb-2 text-sm font-semibold">running</div>
              <Input
                type={"Number"}
                value={metaData.report_limits.running}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.report_limits["running"] = Number(
                    e.target.value
                  );
                  setMetaData(new_meta_data);
                }}
              />
              <div className="mt-4 mb-2 text-sm font-semibold">daily</div>
              <Input
                type={"Number"}
                value={metaData.report_limits.daily}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.report_limits["daily"] = Number(e.target.value);
                  setMetaData(new_meta_data);
                }}
              />
              <div className="mt-4 mb-2 text-sm font-semibold">monthly</div>
              <Input
                type={"Number"}
                value={metaData.report_limits.monthly}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.report_limits["monthly"] = Number(
                    e.target.value
                  );
                  setMetaData(new_meta_data);
                }}
              />

              <div className="mt-4 mb-2 text-sm font-semibold">yearly</div>
              <Input
                type={"Number"}
                value={metaData.report_limits.yearly}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.report_limits["yearly"] = Number(
                    e.target.value
                  );
                  setMetaData(new_meta_data);
                }}
              />
            </div>

            {/* msal_config */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>msal_config (SSO)</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("msal_config")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("msal_config")
                        ? prev.filter((item) => item !== "msal_config")
                        : [...prev, "msal_config"]
                    );
                  }}
                />
              </div>

              <div className="mt-4 mb-2 text-sm font-semibold">clientId</div>
              <Input
                type={"text"}
                value={metaData.msal_config.clientId}
                placeholder={"f2109ae0-xxxx-xxxx-xxxx-ac3ba17fbf9a"}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.msal_config["clientId"] = e.target.value;
                  setMetaData(new_meta_data);
                }}
              />

              <div className="mt-4 mb-2 text-sm font-semibold">authority</div>
              <Input
                type={"text"}
                placeholder={
                  "https://login.microsoftonline.com/a6917215-25de-xxxx-xxxx-fd224e9238e7"
                }
                value={metaData.msal_config.authority}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.msal_config["authority"] = e.target.value;
                  setMetaData(new_meta_data);
                }}
              />

              <div className="mt-4 mb-2 text-sm font-semibold">tenant_id</div>
              <Input
                type={"text"}
                value={metaData.msal_config.tenant_id}
                placeholder={"Enter tenant_id"}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.msal_config["tenant_id"] = e.target.value;
                  setMetaData(new_meta_data);
                }}
              />
            </div>

            {/* external_access     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>External access</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("external_access")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("external_access")
                        ? prev.filter((item) => item !== "external_access")
                        : [...prev, "external_access"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                enabled :
                <input
                  type="checkbox"
                  checked={metaData.external_access.enabled}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.external_access["enabled"] =
                      !metaData.external_access.enabled;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">sasToken</div>
              <Input
                type={"text"}
                placeholder={"Enter sasToken"}
                value={metaData.external_access.sasToken}
                onChange={(e) => {
                  let new_meta_data = JSON.parse(JSON.stringify(metaData));
                  new_meta_data.external_access["sasToken"] = e.target.value;
                  setMetaData(new_meta_data);
                }}
              />
            </div>

            <div className="flex items-center gap-x-2">
              <button
                title="Go Back and Edit"
                className="flex items-center gap-1 px-2 py-1 mt-2 border rounded-lg"
                onClick={() => {
                  setSteps((prev) => prev - 1);
                }}
              >
                <MdArrowBack />
              </button>

              <button
                disabled={isLoading}
                className="flex gap-1 items-center px-2 py-1 mt-2 border border-black bg-black disabled:bg-[#b6b6b6] disabled:text-white text-white rounded-lg"
                onClick={() => {
                  setSteps((prev) => prev + 1);
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
        {steps == 2 && (
          <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
            <p className="mb-4 text-2xl font-semibold">Meta Part 2</p>

            {/* pitchbook_api_key     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Pitchbook Api Key</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("pitchbook_api_key")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("pitchbook_api_key")
                        ? prev.filter((item) => item !== "pitchbook_api_key")
                        : [...prev, "pitchbook_api_key"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                placeholder={"Enter pitchbook_api_key"}
                value={metaData.pitchbook_api_key}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    pitchbook_api_key: e.target.value,
                  });
                }}
              />
            </div>

            {/* pitchbook_proxy     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Pitchbook Proxy</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("pitchbook_proxy")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("pitchbook_proxy")
                        ? prev.filter((item) => item !== "pitchbook_proxy")
                        : [...prev, "pitchbook_proxy"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                value={metaData.pitchbook_proxy}
                placeholder={"Enter pitchbook_proxy"}
                onChange={(e) => {
                  setMetaData({ ...metaData, pitchbook_proxy: e.target.value });
                }}
              />
            </div>

            {/* pitchbook_proxy     */}
            {/* <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Pitchbook Proxy</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("pitchbook_proxy")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("pitchbook_proxy")
                        ? prev.filter((item) => item !== "pitchbook_proxy")
                        : [...prev, "pitchbook_proxy"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                value={metaData.pitchbook_proxy}
                placeholder={"Enter pitchbook_proxy"}
                onChange={(e) => {
                  setMetaData({ ...metaData, pitchbook_proxy: e.target.value });
                }}
              />
            </div> */}

            {/* webhook     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Webhook</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("webhook")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("webhook")
                        ? prev.filter((item) => item !== "webhook")
                        : [...prev, "webhook"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                value={metaData.webhook}
                placeholder={"Enter webhook"}
                onChange={(e) => {
                  setMetaData({ ...metaData, webhook: e.target.value });
                }}
              />
            </div>

            {/* zapier_webhook     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Zapier webhook</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("zapier_webhook")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("zapier_webhook")
                        ? prev.filter((item) => item !== "zapier_webhook")
                        : [...prev, "zapier_webhook"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                value={metaData.zapier_webhook}
                placeholder={"Enter zapier_webhook"}
                onChange={(e) => {
                  setMetaData({ ...metaData, zapier_webhook: e.target.value });
                }}
              />
            </div>

            {/* email_workflow_authentication_key     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>email_workflow_authentication_key</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes(
                    "email_workflow_authentication_key"
                  )}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes(
                        "email_workflow_authentication_key"
                      )
                        ? prev.filter(
                            (item) =>
                              item !== "email_workflow_authentication_key"
                          )
                        : [...prev, "email_workflow_authentication_key"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                value={metaData.email_workflow_authentication_key}
                placeholder={"Enter email_workflow_authentication_key"}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    email_workflow_authentication_key: e.target.value,
                  });
                }}
              />
            </div>

            {/* total_seats */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Total seats</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("total_seats")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("total_seats")
                        ? prev.filter((item) => item !== "total_seats")
                        : [...prev, "total_seats"]
                    );
                  }}
                />
              </div>
              <Input
                type={"number"}
                value={metaData.total_seats}
                placeholder={"Enter total_seats"}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    total_seats: Number(e.target.value),
                  });
                }}
              />
            </div>

            {/* allowded_domains */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Allowed domains(',' seperated)</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("allowded_domains")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("allowded_domains")
                        ? prev.filter((item) => item !== "allowded_domains")
                        : [...prev, "allowded_domains"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                value={metaData.allowded_domains.join(",")}
                placeholder={"Enter allowded_domains"}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    allowded_domains: e.target.value.split(","),
                  });
                }}
              />
            </div>

            <div className="flex items-center gap-x-2">
              <button
                title="Go Back and Edit"
                className="flex items-center gap-1 px-2 py-1 mt-2 border rounded-lg"
                onClick={() => {
                  setSteps((prev) => prev - 1);
                }}
              >
                <MdArrowBack />
              </button>

              <button
                disabled={isLoading}
                className="flex gap-1 items-center px-2 py-1 mt-2 border border-black bg-black disabled:bg-[#b6b6b6] disabled:text-white text-white rounded-lg"
                onClick={() => {
                  setSteps((prev) => prev + 1);
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
        {steps == 3 && (
          <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
            <p className="mb-4 text-2xl font-semibold">Meta Part 3</p>
            {/* disabled export     */}

            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>validate_token</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("validate_token")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("validate_token")
                        ? prev.filter((item) => item !== "validate_token")
                        : [...prev, "validate_token"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                {/* validate_token : */}
                <input
                  type="checkbox"
                  checked={metaData.validate_token}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.validate_token = !metaData.validate_token;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* disabled_share : */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>disabled_share</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("disabled_share")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("disabled_share")
                        ? prev.filter((item) => item !== "disabled_share")
                        : [...prev, "disabled_share"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.disabled_share}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.disabled_share = !metaData.disabled_share;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* is_email_research_allowed : */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>is_email_research_allowed</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes(
                    "is_email_research_allowed"
                  )}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("is_email_research_allowed")
                        ? prev.filter(
                            (item) => item !== "is_email_research_allowed"
                          )
                        : [...prev, "is_email_research_allowed"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.is_email_research_allowed}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.is_email_research_allowed =
                      !metaData.is_email_research_allowed;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* custom_workflow_enable : */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>custom_workflow_enable</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("custom_workflow_enable")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("custom_workflow_enable")
                        ? prev.filter(
                            (item) => item !== "custom_workflow_enable"
                          )
                        : [...prev, "custom_workflow_enable"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.custom_workflow_enable}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.custom_workflow_enable =
                      !metaData.custom_workflow_enable;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* custom_agents_enable : */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>custom_agents_enable</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("custom_agents_enable")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("custom_agents_enable")
                        ? prev.filter(
                            (item) => item !== "custom_agents_enable"
                          )
                        : [...prev, "custom_agents_enable"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.custom_agents_enable}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.custom_agents_enable =
                      !metaData.custom_agents_enable;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* newsletter_custom_analysis : */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>newsletter_custom_analysis</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes(
                    "newsletter_custom_analysis"
                  )}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("newsletter_custom_analysis")
                        ? prev.filter(
                            (item) => item !== "newsletter_custom_analysis"
                          )
                        : [...prev, "newsletter_custom_analysis"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.newsletter_custom_analysis}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.newsletter_custom_analysis =
                      !metaData.newsletter_custom_analysis;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* enable_newsletter_export       */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>enable_newsletter_export</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("enable_newsletter_export")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("enable_newsletter_export")
                        ? prev.filter(
                            (item) => item !== "enable_newsletter_export"
                          )
                        : [...prev, "enable_newsletter_export"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.enable_newsletter_export}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.enable_newsletter_export =
                      !metaData.enable_newsletter_export;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* enabled_connectors     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>enabled_connectors</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("enabled_connectors")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("enabled_connectors")
                        ? prev.filter((item) => item !== "enabled_connectors")
                        : [...prev, "enabled_connectors"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                google_drive :
                <input
                  type="checkbox"
                  checked={metaData.enabled_connectors.google_drive}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.enabled_connectors["google_drive"] =
                      !metaData.enabled_connectors.google_drive;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                dropbox :
                <input
                  type="checkbox"
                  checked={metaData.enabled_connectors.dropbox}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.enabled_connectors["dropbox"] =
                      !metaData.enabled_connectors.dropbox;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* cache_time_period  */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>cache_time_period</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("cache_time_period")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("cache_time_period")
                        ? prev.filter((item) => item !== "cache_time_period")
                        : [...prev, "cache_time_period"]
                    );
                  }}
                />
              </div>
              <Input
                type={"number"}
                value={metaData.cache_time_period}
                placeholder={"Enter cache_time_period "}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    cache_time_period: Number(e.target.value),
                  });
                }}
              />
            </div>

            {/* disabled export     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>disabled_export</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("disabled_export")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("disabled_export")
                        ? prev.filter((item) => item !== "disabled_export")
                        : [...prev, "disabled_export"]
                    );
                  }}
                />
              </div>
              <input
                type="checkbox"
                checked={
                  metaData.disabled_export == true ||
                  metaData.disabled_export == 1
                }
                onClick={() => {
                  let newPrev = JSON.parse(JSON.stringify(metaData));
                  if (
                    newPrev.disabled_export == true ||
                    newPrev.disabled_export == 1
                  ) {
                    newPrev["disabled_export"] = 0;
                  } else {
                    newPrev["disabled_export"] = 1;
                  }
                  console.log(newPrev);
                  setMetaData(newPrev);
                }}
              />
            </div>

            {/* Permalink     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>Permalink</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("permalink")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("permalink")
                        ? prev.filter((item) => item !== "permalink")
                        : [...prev, "permalink"]
                    );
                  }}
                />
              </div>
              <Input
                type={"text"}
                value={metaData.permalink}
                placeholder={"Enter permalink"}
                readOnly={false}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    permalink: e.target.value,
                  });
                }}
              />

              <div className="mt-2" />
              <Input
                type={"text"}
                value={metaCompanySearchForPermalink}
                placeholder={"Enter company name"}
                onChange={(e) => {
                  setMetaCompanySearchForPermalink(e.target.value);
                }}
              />
              <div className="overflow-x-auto h-[180px]  overflow-y-auto mt-4 border rounded-lg">
                <table className="w-full">
                  <thead className="text-left border-b">
                    <th className="px-2 py-1 text-sm text-gray-700">Action</th>
                    <th className="px-2 py-1 text-sm text-gray-700">
                      permalink
                    </th>
                    <th className="px-2 py-1 text-sm text-gray-700">name</th>
                    <th className="px-2 py-1 text-sm text-gray-700">
                      founded_year
                    </th>
                    <th className="px-2 py-1 text-sm text-gray-700">
                      ipo_status
                    </th>
                    <th className="px-2 py-1 text-sm text-gray-700">country</th>
                    <th className="px-2 py-1 w-[100px] text-gray-700 text-sm">
                      short_description
                    </th>
                  </thead>
                  <tbody className="divide-y">
                    {metaPeramlinkResultsLoading ? (
                      <>Loading...</>
                    ) : (
                      <>
                        {metaCompanySearchResults.map((result, index) => {
                          return (
                            <tr key={index} className="bg-white odd:bg-gray-50">
                              <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                <button
                                  onClick={() => {
                                    setMetaData({
                                      ...metaData,
                                      permalink: result.permalink,
                                    });
                                  }}
                                  className="px-2 py-1 text-xs text-white bg-black rounded-sm"
                                >
                                  set permalink
                                </button>
                              </td>
                              <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                {result.permalink}
                              </td>
                              <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                {result.name}
                              </td>
                              <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                {result.founded_year}
                              </td>
                              <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                {result.ipo_status}
                              </td>
                              <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                {result.country}
                              </td>
                              <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                                {result.short_description}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                  {isMetaPermalinkShowMoreOn && (
                    <button
                      disabled={metaPeramlinkResultsLoading}
                      className="px-2 py-1 text-sm rounded-lg disabled:cursor-not-allowed"
                      onClick={() => {
                        setIsMetaPermalinkShowMoreButtonOn(false);
                        setMetaPermalinkResultsLoading(true);
                        axiosInstance
                          .post("/assets/get_company_list/", {
                            company_type: "all",
                            name: metaPermalinkQuery,
                            search_by: "company name",
                            global: true,
                          })
                          .then((res) => {
                            setMetaCompanySearchResults(res.data.data);
                            setMetaPermalinkResultsLoading(false);
                          })
                          .catch((err) => {
                            console.log(err);
                            setMetaPermalinkResultsLoading(false);
                          });
                      }}
                    >
                      {metaPeramlinkResultsLoading ? "Loading..." : "Show more"}
                    </button>
                  )}
                </table>
              </div>
            </div>

            {/* SSO ENABLED     */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>sso_enabled</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("sso_enabled")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("sso_enabled")
                        ? prev.filter((item) => item !== "sso_enabled")
                        : [...prev, "sso_enabled"]
                    );
                  }}
                />
              </div>
              {["azuread", "google"].map((item) => {
                return (
                  <div>
                    <p>{item}</p>
                    <input
                      type="checkbox"
                      checked={metaData.sso_enabled.includes(item)}
                      onClick={() => {
                        setMetaData((prev) => {
                          return {
                            ...prev,
                            sso_enabled: metaData.sso_enabled.includes(item)
                              ? JSON.parse(
                                  JSON.stringify(metaData.sso_enabled)
                                ).filter((i) => i != item)
                              : [
                                  ...JSON.parse(
                                    JSON.stringify(metaData.sso_enabled)
                                  ),
                                  item,
                                ],
                          };
                        });
                      }}
                    />
                  </div>
                );
              })}
            </div>

            {/* enable_uploaded_file_page */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>enable_uploaded_file_page (vault) </p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes(
                    "enable_uploaded_file_page"
                  )}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("enable_uploaded_file_page")
                        ? prev.filter(
                            (item) => item !== "enable_uploaded_file_page"
                          )
                        : [...prev, "enable_uploaded_file_page"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.enable_uploaded_file_page}
                  onChange={(e) => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.enable_uploaded_file_page =
                      !metaData.enable_uploaded_file_page;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            <div className="flex items-center gap-x-2">
              <button
                title="Go Back and Edit"
                className="flex items-center gap-1 px-2 py-1 mt-2 border rounded-lg"
                onClick={() => {
                  setSteps((prev) => prev - 1);
                }}
              >
                <MdArrowBack />
              </button>

              <button
                disabled={isLoading}
                className="flex gap-1 items-center px-2 py-1 mt-2 border border-black bg-black disabled:bg-[#b6b6b6] disabled:text-white text-white rounded-lg"
                onClick={() => {
                  setSteps((prev) => prev + 1);
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
        {steps == 4 && (
          <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
            <p className="mb-4 text-2xl font-semibold">Meta Part 4 (PPT Generator)</p>

            {/* disabled_file_upload_ppt_generator */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>disabled_file_upload_ppt_generator</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("disabled_file_upload_ppt_generator")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("disabled_file_upload_ppt_generator")
                        ? prev.filter((item) => item !== "disabled_file_upload_ppt_generator")
                        : [...prev, "disabled_file_upload_ppt_generator"]
                    );
                  }}
                />
              </div>
              <div className="mt-4 mb-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={metaData.disabled_file_upload_ppt_generator}
                  onChange={() => {
                    let new_meta_data = JSON.parse(JSON.stringify(metaData));
                    new_meta_data.disabled_file_upload_ppt_generator =
                      !metaData.disabled_file_upload_ppt_generator;
                    setMetaData(new_meta_data);
                  }}
                />
              </div>
            </div>

            {/* ppt_generator_max_number_of_slides */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>ppt_generator_max_number_of_slides</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("ppt_generator_max_number_of_slides")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("ppt_generator_max_number_of_slides")
                        ? prev.filter((item) => item !== "ppt_generator_max_number_of_slides")
                        : [...prev, "ppt_generator_max_number_of_slides"]
                    );
                  }}
                />
              </div>
              <Input
                type={"number"}
                value={metaData.ppt_generator_max_number_of_slides}
                placeholder={"Enter ppt_generator_max_number_of_slides"}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    ppt_generator_max_number_of_slides: Number(e.target.value),
                  });
                }}
              />
            </div>

            {/* ppt_generator_file_attachment_limit_single_slide */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>ppt_generator_file_attachment_limit_single_slide</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("ppt_generator_file_attachment_limit_single_slide")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("ppt_generator_file_attachment_limit_single_slide")
                        ? prev.filter((item) => item !== "ppt_generator_file_attachment_limit_single_slide")
                        : [...prev, "ppt_generator_file_attachment_limit_single_slide"]
                    );
                  }}
                />
              </div>
              <Input
                type={"number"}
                value={metaData.ppt_generator_file_attachment_limit_single_slide}
                placeholder={"Enter ppt_generator_file_attachment_limit_single_slide"}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    ppt_generator_file_attachment_limit_single_slide: Number(e.target.value),
                  });
                }}
              />
            </div>

            {/* ppt_generator_file_attachment_limit_multi_slide */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>ppt_generator_file_attachment_limit_multi_slide</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("ppt_generator_file_attachment_limit_multi_slide")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("ppt_generator_file_attachment_limit_multi_slide")
                        ? prev.filter((item) => item !== "ppt_generator_file_attachment_limit_multi_slide")
                        : [...prev, "ppt_generator_file_attachment_limit_multi_slide"]
                    );
                  }}
                />
              </div>
              <Input
                type={"number"}
                value={metaData.ppt_generator_file_attachment_limit_multi_slide}
                placeholder={"Enter ppt_generator_file_attachment_limit_multi_slide"}
                onChange={(e) => {
                  setMetaData({
                    ...metaData,
                    ppt_generator_file_attachment_limit_multi_slide: Number(e.target.value),
                  });
                }}
              />
            </div>

            {/* ppt_generator_types_of_file_upload_single_slide */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>ppt_generator_types_of_file_upload_single_slide</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("ppt_generator_types_of_file_upload_single_slide")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("ppt_generator_types_of_file_upload_single_slide")
                        ? prev.filter((item) => item !== "ppt_generator_types_of_file_upload_single_slide")
                        : [...prev, "ppt_generator_types_of_file_upload_single_slide"]
                    );
                  }}
                />
              </div>
              <Select
                isMulti
                value={(metaData.ppt_generator_types_of_file_upload_single_slide || []).map((v) => ({ value: v, label: v }))}
                onChange={(selected) => {
                  setMetaData({
                    ...metaData,
                    ppt_generator_types_of_file_upload_single_slide: selected ? selected.map((s) => s.value) : [],
                  });
                }}
                options={[
                  { value: "image", label: "image" },
                  { value: "pdf", label: "pdf" },
                  { value: "excel", label: "excel" },
                ]}
                className="w-full"
              />
            </div>

            {/* ppt_generator_types_of_file_upload_multi_slide */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>ppt_generator_types_of_file_upload_multi_slide</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("ppt_generator_types_of_file_upload_multi_slide")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("ppt_generator_types_of_file_upload_multi_slide")
                        ? prev.filter((item) => item !== "ppt_generator_types_of_file_upload_multi_slide")
                        : [...prev, "ppt_generator_types_of_file_upload_multi_slide"]
                    );
                  }}
                />
              </div>
              <Select
                isMulti
                value={(metaData.ppt_generator_types_of_file_upload_multi_slide || []).map((v) => ({ value: v, label: v }))}
                onChange={(selected) => {
                  setMetaData({
                    ...metaData,
                    ppt_generator_types_of_file_upload_multi_slide: selected ? selected.map((s) => s.value) : [],
                  });
                }}
                options={[
                  { value: "image", label: "image" },
                  { value: "pdf", label: "pdf" },
                  { value: "excel", label: "excel" },
                ]}
                className="w-full"
              />
            </div>

            {/* ppt_generator_approch_single_slide */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>ppt_generator_approch_single_slide</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("ppt_generator_approch_single_slide")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("ppt_generator_approch_single_slide")
                        ? prev.filter((item) => item !== "ppt_generator_approch_single_slide")
                        : [...prev, "ppt_generator_approch_single_slide"]
                    );
                  }}
                />
              </div>
              <Select
                isMulti
                value={(metaData.ppt_generator_approch_single_slide || []).map((v) => ({ value: v, label: v }))}
                onChange={(selected) => {
                  setMetaData({
                    ...metaData,
                    ppt_generator_approch_single_slide: selected ? selected.map((s) => s.value) : [],
                  });
                }}
                options={[
                  { value: "design_only", label: "design_only" },
                  { value: "research_design", label: "research_design" },
                ]}
                className="w-full"
              />
            </div>

            {/* ppt_generator_approch_multi_slide */}
            <div className="p-2 mt-4 rounded bg-slate-200">
              <div className="flex items-center justify-between mb-2 text-lg font-semibold">
                <p>ppt_generator_approch_multi_slide</p>
                <input
                  type="checkbox"
                  checked={enabledMetaKeys.includes("ppt_generator_approch_multi_slide")}
                  onClick={() => {
                    setEnabledMetaKeys((prev) =>
                      enabledMetaKeys.includes("ppt_generator_approch_multi_slide")
                        ? prev.filter((item) => item !== "ppt_generator_approch_multi_slide")
                        : [...prev, "ppt_generator_approch_multi_slide"]
                    );
                  }}
                />
              </div>
              <Select
                isMulti
                value={(metaData.ppt_generator_approch_multi_slide || []).map((v) => ({ value: v, label: v }))}
                onChange={(selected) => {
                  setMetaData({
                    ...metaData,
                    ppt_generator_approch_multi_slide: selected ? selected.map((s) => s.value) : [],
                  });
                }}
                options={[
                  { value: "design_only", label: "design_only" },
                  { value: "research_design", label: "research_design" },
                ]}
                className="w-full"
              />
            </div>

            <div className="flex items-center gap-x-2">
              <button
                title="Go Back and Edit"
                className="flex items-center gap-1 px-2 py-1 mt-2 border rounded-lg"
                onClick={() => {
                  setSteps((prev) => prev - 1);
                }}
              >
                <MdArrowBack />
              </button>

              <button
                className="bg-black disabled:bg-[#B6b6b6] disabled:cursor-not-allowed disabled:text-white text-white py-3 hover:shadow-lg text-center w-full rounded-lg mt-4"
                type="button"
                disabled={
                  errorInName !== "" ||
                  formData.name === "" ||
                  formData.account_type === ""
                }
                onClick={() => {
                  const preservedTrialToPaid = formData?.meta?.trial_to_paid_date;
                  const preservedNextRenewalDate = formData?.meta?.next_renewal_date;
                  let metaNewData = JSON.parse(JSON.stringify(metaData));
                  if (metaNewData.logo === null) { metaNewData["logo"] = ""; }
                  if (metaNewData.webhook == null) { metaNewData["webhook"] = ""; }
                  if (metaNewData.permalink == null) { metaNewData["permalink"] = ""; }
                  if (metaNewData.zapier_webhook == null) { metaNewData["zapier_webhook"] = ""; }
                  if (metaNewData.pitchbook_proxy == null) { metaNewData["pitchbook_proxy"] = ""; }
                  if (metaNewData.pitchbook_api_key == null) { metaNewData["pitchbook_api_key"] = ""; }
                  if (metaNewData.external_access.sasToken == null) {
                    let external_access = JSON.parse(JSON.stringify(metaNewData.external_access));
                    external_access["sasToken"] = "";
                    metaNewData.external_access = external_access;
                  }
                  if (metaNewData.trial_to_paid_date == null || metaNewData.trial_to_paid_date === "") {
                    delete metaNewData.trial_to_paid_date;
                  }
                  Object.keys(metaNewData).forEach((key) => {
                    if (!enabledMetaKeys.includes(key)) { delete metaNewData[key]; }
                    if (metaNewData.trial_to_paid_date == null || metaNewData.trial_to_paid_date === "") {
                      delete metaNewData.trial_to_paid_date;
                    }
                    if (metaNewData.next_renewal_date == null || metaNewData.next_renewal_date === "") {
                      delete metaNewData.next_renewal_date;
                    }
                    Object.keys(metaNewData).forEach((key) => {
                      if (!enabledMetaKeys.includes(key)) { delete metaNewData[key]; }
                    });
                    if (preservedTrialToPaid) { metaNewData.trial_to_paid_date = preservedTrialToPaid; }
                    if (preservedNextRenewalDate) { metaNewData.next_renewal_date = preservedNextRenewalDate; }
                    setFormData((prev) => ({ ...prev, meta: metaNewData }));
                    setSteps(5);
                  });
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
        {steps == 5 && (
          <Preview
            isLoading={isLoading}
            setSteps={setSteps}
            formData={formData}
            handleSubmit={handleSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditOrganisation;

const Preview = ({ formData, setSteps, isLoading, handleSubmit }) => {
  return (
    <div>
      <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
        <p className="mb-4 text-2xl font-semibold">Meta Data Preview</p>
        <div className="px-3 py-2 border rounded-xl bg-gray-50">
          {/* "overflow-y:scroll; max-width:400px; height:80px; border:0.5px solid lightgray; padding:5px; white-space:pre-wrap;" */}
          <pre
            style={{
              overflowY: "scroll",
              maxWidth: "100%",
              height: "80vh",
              whiteSpace: "pre-wrap",
            }}
          >
            {JSON.stringify(formData.meta, {}, 4)}
          </pre>
        </div>
        <div className="flex justify-between">
          <button
            title="Go Back and Edit"
            className="flex items-center gap-1 px-2 py-1 mt-2 border rounded-lg"
            onClick={() => {
              setSteps((prev) => prev - 1);
            }}
          >
            <MdArrowBack />
          </button>

          <button
            disabled={isLoading}
            title="Go Back and Edit"
            className="flex gap-1 items-center px-2 py-1 mt-2 border border-black bg-black disabled:bg-[#b6b6b6] disabled:text-white text-white rounded-lg"
            onClick={() => {
              handleSubmit();
            }}
          >
            {!isLoading ? "Edit this Org" : "Loading...."}
          </button>
        </div>
      </div>
    </div>
  );
};
